import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { QueryClient } from 'react-query';
import { QueryConfigTypes } from '../../apis-infra';
import { QUERY_CONFIGS } from './queryConfigTypes';

/**
 * @param params:
 * @param configType: REALTIME / DYNAMIC / STATIC / FIXED according to the change frequency of the data
 * @param options: (optional) other react-query client options
 */
export const createQueryClient = params => {
  var _params$configType;
  return new QueryClient({
    defaultOptions: {
      queries: {
        ...QUERY_CONFIGS[(_params$configType = params == null ? void 0 : params.configType) != null ? _params$configType : QueryConfigTypes.DYNAMIC_DATA],
        retry: 0
      },
      mutations: {
        retry: 0
      }
    },
    ...(params == null ? void 0 : params.options)
  });
};
export class QueryClientInstance {
  constructor() {
    _defineProperty(this, "queryClient", void 0);
    this.queryClient = createQueryClient();
  }
  static get Instance() {
    if (this.instance == null) {
      this.instance = new QueryClientInstance();
    }
    return this.instance;
  }
  clear() {
    this.queryClient.clear();
  }
}
_defineProperty(QueryClientInstance, "instance", null);
//# sourceMappingURL=queryClientInstance.js.map